// src/store/reward/reward.store.ts
import { create } from "zustand";

interface RewardStore {
  page: number;
  size: number;
  sort: string[];
  setQuery: (params: Partial<{ page: number; size: number; sort: string[] }>) => void;
}

export const useRewardStore = create<RewardStore>((set) => ({
  page: 1,
  size: 20,
  sort: [],
  setQuery: (params) => set((state) => ({ ...state, ...params })),
}));
